// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__18AH2","alertIcon":"ConfirmModal_alertIcon__1eY1D"};